import React, { useState, FC, ReactNode } from 'react';
import { PaymentTrackerContext } from './context';
import { PaymentRequestDetailType } from 'models/payment-tracker.model';

const PaymentTrackerProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [paymentItemToEdit, setPaymentItemToEdit] = useState<PaymentRequestDetailType | null>(null);

  return (
    <PaymentTrackerContext.Provider
      value={{
        paymentItemToEdit,
        setPaymentItemToEdit
      }}>
      {children}
    </PaymentTrackerContext.Provider>
  );
};

export default PaymentTrackerProvider;
